const weatherMap = new Map();
weatherMap.set(0, "Soleil")
weatherMap.set(1, "Nuageux")
weatherMap.set(2, "Nuageux")
weatherMap.set(3, "Nuageux")
weatherMap.set(4, "Nuageux")
weatherMap.set(5, "Nuageux")
weatherMap.set(6, "Brouillard")
weatherMap.set(7, "Brouillard givrant")
weatherMap.set(10, "Pluie faible")
weatherMap.set(11, "Pluie modérée")
weatherMap.set(12, "Pluie forte")
weatherMap.set(13, "Pluie faible verglaçante")
weatherMap.set(14, "Pluie modérée verglaçante")
weatherMap.set(15, "Pluie forte verglaçante")
weatherMap.set(16, "Pluie")
weatherMap.set(20, "Neige faible")
weatherMap.set(21, "Neige modérée")
weatherMap.set(22, "Neige forte")
weatherMap.set(30, "Pluie et neige mêlées faibles")
weatherMap.set(31, "Pluie et neige mêlées modérées")
weatherMap.set(32, "Pluie et neige mêlées fortes")
weatherMap.set(40, "Averses de pluie locales et faibles")
weatherMap.set(41, "Averses de pluie locales")
weatherMap.set(42, "Averses locales et fortes")
weatherMap.set(43, "Averses de pluie faibles")
weatherMap.set(44, "Averses de pluie")
weatherMap.set(45, "Averses de pluie fortes")
weatherMap.set(46, "Averses de pluie faibles et fréquentes")
weatherMap.set(47, "Averses de pluie fréquentes")
weatherMap.set(48, "Averses de pluie fortes et fréquentes")
weatherMap.set(60, "Averses de neige localisées et faibles")
weatherMap.set(61, "Averses de neige localisées")
weatherMap.set(62, "Averses de neige localisées et fortes")
weatherMap.set(63, "Averses de neige faibles")
weatherMap.set(64, "Averses de neige")
weatherMap.set(65, "Averses de neige fortes")
weatherMap.set(66, "Averses de neige faibles et fréquentes")
weatherMap.set(67, "Averses de neige fréquentes")
weatherMap.set(68, "Averses de neige fortes et fréquentes")
weatherMap.set(70, "Averses de pluie et neige mêlées localisées et faibles")
weatherMap.set(71, "Averses de pluie et neige mêlées localisées")
weatherMap.set(72, "Averses de pluie et neige mêlées localisées et fortes")
weatherMap.set(73, "Averses de pluie et neige mêlées faibles")
weatherMap.set(74, "Averses de pluie et neige mêlées")
weatherMap.set(75, "Averses de pluie et neige mêlées fortes")
weatherMap.set(76, "Averses de pluie et neige mêlées faibles et nombreuses")
weatherMap.set(77, "Averses de pluie et neige mêlées fréquentes")
weatherMap.set(78, "Averses de pluie et neige mêlées fortes et fréquentes")
weatherMap.set(100, "Orages faibles et locaux")
weatherMap.set(101, "Orages locaux")
weatherMap.set(102, "Orages fort et locaux")
weatherMap.set(103, "Orages faibles")
weatherMap.set(104, "Orages")
weatherMap.set(105, "Orages forts")
weatherMap.set(106, "Orages faibles et fréquents")
weatherMap.set(107, "Orages fréquents")
weatherMap.set(108, "Orages forts et fréquents")
weatherMap.set(120, "Orages faibles et locaux de neige ou grésil")
weatherMap.set(121, "Orages locaux de neige ou grésil")
weatherMap.set(122, "Orages locaux de neige ou grésil")
weatherMap.set(123, "Orages faibles de neige ou grésil")
weatherMap.set(124, "Orages de neige ou grésil")
weatherMap.set(125, "Orages de neige ou grésil")
weatherMap.set(126, "Orages faibles et fréquents de neige ou grésil")
weatherMap.set(127, "Orages fréquents de neige ou grésil")
weatherMap.set(128, "Orages fréquents de neige ou grésil")
weatherMap.set(130, "Orages faibles et locaux de pluie et neige mêlées ou grésil")
weatherMap.set(131, "Orages locaux de pluie et neige mêlées ou grésil")
weatherMap.set(132, "Orages fort et locaux de pluie et neige mêlées ou grésil")
weatherMap.set(133, "Orages faibles de pluie et neige mêlées ou grésil")
weatherMap.set(134, "Orages de pluie et neige mêlées ou grésil")
weatherMap.set(135, "Orages forts de pluie et neige mêlées ou grésil")
weatherMap.set(136, "Orages faibles et fréquents de pluie et neige mêlées ou grésil")
weatherMap.set(137, "Orages fréquents de pluie et neige mêlées ou grésil")
weatherMap.set(138, "Orages forts et fréquents de pluie et neige mêlées ou grésil")
weatherMap.set(140, "Pluies orageuses")
weatherMap.set(141, "Pluie et neige mêlées à caractère orageux")
weatherMap.set(142, "Neige à caractère orageux")
weatherMap.set(210, "Pluie faible intermittente")
weatherMap.set(211, "Pluie modérée intermittente")
weatherMap.set(212, "Pluie forte intermittente")
weatherMap.set(220, "Neige faible intermittente")
weatherMap.set(221, "Neige modérée intermittente")
weatherMap.set(222, "Neige forte intermittente")
weatherMap.set(230, "Pluie et neige mêlées")
weatherMap.set(231, "Pluie et neige mêlées")
weatherMap.set(232, "Pluie et neige mêlées")
weatherMap.set(235, "Neige")

export default weatherMap;